IREP.certificatesUserControl = (function() {
    var DoAnimation = function() {
        var certificateTimeline = new TimelineMax();
        certificateTimeline
            .to($('#Certificate'), .15, { opacity: 1 })
            .add(TweenMax.staggerFrom($('.CertificateType'), .5, { opacity: 0, marginTop: "25px", display: "none" }, .5),
                TweenMax.staggerFrom($('.letterHead'), .5, { opacity: 0, marginTop: "25px", display: "none" }, .5)
            )
            .add([TweenMax.staggerFrom($('.NameStyle'), 0.25, { opacity: 0, paddingLeft: "0px" }, .5),
                TweenMax.staggerFrom($('.downloadpdf'), .25, { opacity: 0, marginLeft: "60px", display: "none" }, .5),
                TweenMax.staggerTo($('.NameStyle'), .25, { color: "#333333", delay: .25 }, .5)
            ]);
    };

    return {
        DoAnimation: DoAnimation
    };
})();